import tw from 'twin.macro';
import 'styled-components/macro';

import { TextButton } from 'component-lib/atoms/button/Button';
import { UserProfile } from 'types/graphql';

export interface AccountButtonProps {
  onClick?: () => void;
  open?: boolean;
  profile: Pick<UserProfile, 'avatar' | 'display_name'>;
}

export const AccountButton = ({ onClick, open, profile, ...props }: AccountButtonProps) => (
  <TextButton onClick={onClick} tw="px-0" {...props}>
    <div tw="h-4 w-4 rounded-2xl" css={!profile.avatar && tw`bg-gray-5`}>
      {profile.avatar ? (
        <img src={profile.avatar} alt="" tw="rounded-2xl" css={open ? tw`opacity-50` : tw`opacity-100`} />
      ) : (
        profile.display_name?.[0].toUpperCase()
      )}
    </div>
  </TextButton>
);
